import React from 'react';
import {
  Container,
  TitleContainer,
  Title,
  Icon,
  IconUIContainer,
} from './styles';

export default function NavigationCard(props) {
  const { loading = false } = props;

  return (
    <>
      <Container
        hasChildren={props.children ? true : false}
        onClick={props.onClick}
        title={props.title}
        color={props.color}
        hasStatus={props.hasStatus ? true : false}
      >
        {!loading && (
          <TitleContainer hasChildren={props.children ? true : false} ac={props.ac}>
            {props.iconUI ? (
              <IconUIContainer>{props.iconUI}</IconUIContainer>
            ) : (
              <Icon src={`./assets/images/icons/` + props.icon} width={props.iconWidth} ac={props.ac} />
            )}
            <Title title={props.title} color={props.color}>
              {props.title}
            </Title>
          </TitleContainer>
        )}
        {props.children ? props.children : null}
      </Container>
    </>
  );
}
